export interface ReturnsExperienceInput {
  teamInRollout: boolean;
  prefersLegacy: boolean;
}

/**
 * The returns home pages and the redesigned return details page are one
 * experience: a team in the rollout sees it unless the user switched back.
 */
export function resolveReturnsExperience({
  teamInRollout,
  prefersLegacy,
}: ReturnsExperienceInput): { useNewUi: boolean; canSwitch: boolean } {
  return {
    useNewUi: teamInRollout && !prefersLegacy,
    canSwitch: teamInRollout,
  };
}
